<template>
  <div class="container">
    <wrap-container class="w100">
      <footer>
        <p v-safe-html="config.pasos.paso1.footer"></p>
      </footer>
    </wrap-container>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";

export default {
  name: "AppFooter",
  components: { WrapContainer }
};
</script>

<style scoped>
.container {
  background: #043263;
  color: #e4e4e4;
  font-size: 12px;
  line-height: 1.5em;
  padding: 17px;
  margin-left: -17px;
  margin-right: -17px;
  text-align: justify;
  margin-bottom: 0px;
}
</style>
